import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaDireccion } from '../_direccion.js';

/**
 * El saldo de apertura, dentro del grupo `_direccion`.
 *
 * VA EN DIRECCIÓN Y NO EN CONTABILIDAD aunque sea un asiento contable: `app.cargar_saldo_apertura`
 * exige `administrador` y nadie más, igual que los aportes de socios. En `_contabilidad` la contadora
 * vería el formulario entero y recibiría 42501 al confirmar.
 */
export const rutaSaldosApertura = createRoute({
  getParentRoute: () => rutaDireccion,
  path: '/saldos-apertura',
  component: lazyRouteComponent(() => import('./saldos-apertura-pantalla.js'), 'RutaSaldosApertura'),
});
